import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap';
import { cloneDeep } from 'lodash';
import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import {
  ShowHiddenCondition,
  showHiddenOperators,
  ShowHiddenRuleModel,
  ShowHiddenRuleType,
  showHiddenRuleTypes,
  ShowHiddenSatisfyType,
  showHiddenSatisfyTypes
} from '../../../types/control-show-hidden.types';
import { DynamicForm } from '../../../types/dynamic-form.types';
import { controlsTraversalPipe } from '../../../utils/control-translate';
import { isShowConditionValue } from '../show-hidden.util';

@Component({
  selector: 'df-show-hidden-ui',
  templateUrl: './show-hidden-ui.component.html',
  styleUrls: ['./show-hidden-ui.component.scss']
})
export class ShowHiddenUiComponent implements OnInit {
  @Input() title: string;
  @Input() showHiddenRuleModels: ShowHiddenRuleModel[] = []; // ææçè§å
  @Input() dynamicForm: DynamicForm;
  @Input() showHiddenRuleModel: ShowHiddenRuleModel; // å½åè§å

  @Output() modelChange: EventEmitter<ShowHiddenRuleModel> = new EventEmitter<ShowHiddenRuleModel>();

  showHiddenSatisfyTypes = showHiddenSatisfyTypes;
  showHiddenRuleTypes = showHiddenRuleTypes;

  controlNameOptions: { value: string; label: string }[] = [];
  operators: { value: string; label: string }[] = [];
  targetControlNameOptions: { value: string; label: string }[] = [];

  /**
   * è¡¨åæ¯å¦ææï¼æ æ¡ä»¶æ§ä»¶ãæ¡ä»¶ä¸­æ§ä»¶åæä½ä¸è½ä¸ºç©ºãç®æ æ§ä»¶ä¸è½ä¸ºç©º
   *
   */
  get valid(): boolean {
    if (!this.showHiddenRuleModel) {
      return false;
    }

    if (this.showHiddenRuleModel.targetControlsName.length === 0) {
      return false;
    }

    if (this.showHiddenRuleModel.conditions.length === 0) {
      return false;
    }

    // æ¡ä»¶ä¸­æ§ä»¶åç§°åopé½ä¸è½ä¸ºç©º, æ¾ç¤ºå¼è¾å¥æ¡æ¶ï¼å¼ä¸è½ä¸ºç©º
    return !this.showHiddenRuleModel.conditions.find(
      (s) => !s.controlName || !s.op || (isShowConditionValue(s) && !s.value)
    );
  }

  constructor(public activeModal: BsModalRef, private commonConfig: DynamicFormCommonConfig) {}

  ngOnInit() {
    if (!this.showHiddenRuleModel) {
      this.showHiddenRuleModel = {
        showHiddenSatisfyType: ShowHiddenSatisfyType.All,
        showHiddenRuleType: ShowHiddenRuleType.Show,
        conditions: [],
        targetControlsName: []
      };
    } else {
      this.showHiddenRuleModel = cloneDeep(this.showHiddenRuleModel);
    }

    this.getAllControlsNameOptions();
    this.filterControlsName();

    this.resetTargetControlsNameOptions();
    this.filterTargetControlsName();

    this.operators = showHiddenOperators.map((s) => {
      return { label: s.text, value: s.value };
    });
  }

  submit() {
    if (!this.valid) {
      this.commonConfig.log.warn(`æ æ¡ä»¶æ§ä»¶æèè§åæ¡ä»¶ä¸­æ§ä»¶åæä½ä¸è½ä¸ºç©ºï¼ç®æ æ§ä»¶ä¸è½ä¸ºç©º`);
      return;
    }
    this.filterTargetControlsName();
    this.modelChange.emit(this.showHiddenRuleModel);
    this.activeModal.hide();
  }

  filterControlsName() {
    this.showHiddenRuleModel.conditions.forEach((s) => {
      if (!this.controlNameOptions.find((option) => option.value === s.controlName)) {
        s.controlName = undefined;
      }
    });
  }

  filterTargetControlsName() {
    // ä¿®å¤å ä¸ºéé¡¹ç§»é¤ï¼å¯¼è´ç®æ æ§ä»¶é¡µé¢ä¸æ¾ç¤ºï¼ä½æ¯å®éè¿æ¯æå¼çæåµ
    this.showHiddenRuleModel.targetControlsName = this.showHiddenRuleModel.targetControlsName.filter((s) =>
      this.targetControlNameOptions.find((t) => t.value === s)
    );
  }

  conditionControlNameChanged() {
    this.resetTargetControlsNameOptions();
  }

  getAllControlsNameOptions() {
    controlsTraversalPipe(this.dynamicForm.controls, (c) => {
      if (c.model && !c.isContainer) {
        this.controlNameOptions.push({ value: c.model.name, label: c.type + '-' + c.model.name });
      }
    });
    this.controlNameOptions.sort();
  }

  /**
   * éç½®ç®æ æ§ä»¶å¸èéé¡¹
   */
  resetTargetControlsNameOptions() {
    const exceptControlNames = this.exceptControlNames(this.showHiddenRuleModel);
    this.targetControlNameOptions = this.controlNameOptions.filter((s) => {
      return (
        !this.showHiddenRuleModel.conditions.find((c) => c.controlName === s.value) &&
        !exceptControlNames.find((n) => n === s.value)
      );
    });
  }

  isShowConditionValue(condition: ShowHiddenCondition) {
    return isShowConditionValue(condition);
  }

  addCondition() {
    const conditions = this.showHiddenRuleModel.conditions;
    if (conditions.length >= 20) {
      this.commonConfig.log.warn(`åªè½æ·»å 20ä¸ªæ¡ä»¶`);
      return;
    }
    conditions.push({} as ShowHiddenCondition);
  }

  removeCondition(condition: ShowHiddenCondition) {
    this.showHiddenRuleModel.conditions = this.showHiddenRuleModel.conditions.filter((s) => s !== condition);
    this.resetTargetControlsNameOptions();
  }

  /**
   * æé¤çè§åä¸­çç®æ æ§ä»¶
   *
   */
  private exceptControlNames(exceptRuleModel: ShowHiddenRuleModel) {
    let names: string[] = [];
    this.showHiddenRuleModels.forEach((s) => {
      names.push(...s.targetControlsName);
      names = names.filter((name) => !exceptRuleModel.targetControlsName.includes(name));
    });
    return names;
  }
}
